var map = {
	"./huihan/brinton-101.jpg": 87,
	"./huihan/prix-de-west-2021.jpg": 88,
	"./huihan/prix-de-west-2022.jpg": 89,
	"./huihan/small-works-great-wonders.png": 90,
	"./huihan/the-brinton-museum.jpg": 91,
	"./weizhen/the-brinton-museum.jpg": 92
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 37;